import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalSavingAccontImage from "../../assets/static/personal/bank_transfer_1.png";

function MinorAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Minor Account? We’ve got you covered."
        description="Kontriman offers various ways to assist you with your Minor account – via our help center, chat support, and email. Get the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Minor Account</h1>
                  <p>
                    Our Minor Account is designed to help parents or guardians
                    save and manage funds on behalf of their children. It’s a
                    safe, easy-to-use account that encourages good saving habits
                    from an early age.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>No maintenance fees</li>
                    <li>Parental control and oversight</li>
                    <li>Interest earnings on savings</li>
                    <li>Online access for account monitoring</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Child must be under 18 years</li>
                    <li>Birth certificate or national ID of the minor</li>
                    <li>Valid ID of parent or guardian</li>
                    <li>Proof of address for parent or guardian</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Minor Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={personalSavingAccontImage}
                  alt="Minor Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default MinorAccount;
